import type { FormKitNode, FormKitSectionsSchema } from '@formkit/core'
import { whenAvailable, clone } from '@formkit/utils'

export default function floatingLabelsPlugin(node: FormKitNode) {
  if (node.props.family === 'button') return
  if (node.props.type === 'select') return
  if (node.props.type === 'dbc-tel') return
  if (node.props.type === 'dbc-input-mask') return

  node.addProps({
    _labelOffsetLeft: {},
    _labelOffsetTop: {},
    _labelOpacity: {},
    floatingLabel: {
      boolean: true,
    },
  })

  const useFloatingLabels = node.props.floatingLabel

  if (!useFloatingLabels) return

  node.on('created', () => {
    if (!node.context) return
    if (!node.props.definition) return
    if (typeof node.props.definition?.schema !== 'function') return

    const schemaFn = node.props.definition?.schema
    const inputDefinition = clone(node.props.definition)

    calculateLabelOffset(node)

    inputDefinition.schema = (extensions: FormKitSectionsSchema) => {
      extensions.outer = {
        //@ts-ignore
        ...extensions.outer,
        attrs: {
          'data-floating-label': 'true',
        },
      }

      extensions.label = {
        //@ts-ignore
        ...extensions.label,
        attrs: {
          style: {
            left: '$_labelOffsetLeft',
            top: '$_labelOffsetTop',
            opacity: '$_labelOpacity',
          },
        },
      }

      return schemaFn(extensions)
    }

    if (inputDefinition.schemaMemoKey) {
      inputDefinition.schemaMemoKey += '-floating-label'
    }

    node.props.definition = inputDefinition
  })
}

function calculateLabelOffset(node: FormKitNode) {
  if (!node.context?.id) return

  whenAvailable(node.context.id, () => {
    if (!node.context) return

    const inputEl = document.getElementById(node.context?.id) as HTMLElement

    const innerEl = inputEl.parentNode as HTMLElement

    const innerElStyle = window.getComputedStyle(innerEl)

    const paddingLeft = parseInt(innerElStyle.paddingLeft, 10)

    const prefixIconWidth = node.props.prefixIcon ? 24 : 0

    const gapWidth = node.props.prefixIcon ? 6 : 0

    const offsetLeft = paddingLeft + prefixIconWidth + gapWidth

    const paddingTop = parseInt(innerElStyle.paddingTop, 10)

    node.props._labelOffsetLeft = `${offsetLeft}px`
    node.props._labelOffsetTop = `${paddingTop}px`
    node.props._labelOpacity = '1'
  })
}
